import PropTypes from "prop-types";
//Styles
import styled from "styled-components";

const Image = styled.img.attrs(({ className, src, alt }) => ({
  src: src,
  className: className,
  alt: alt
}))`
  width: ${props => props.width || "auto"};
  height: ${props => props.height || "auto"};
  max-height: ${props => props.maxHeight};
  object-fit: ${props => props.objectFit || "cover"};
  border-radius: ${props => props.borderRadius};
`;

Image.defaultProps = {
  src: "http://via.placeholder.com/150x150",
  alt: "image"
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  objectFit: PropTypes.string
};

export default Image;
